import React from 'react';
import { Switch, Route } from 'react-router-dom';
import { useRouter } from 'hooks/use-router';
import LayoutDashboard from '../../layout';
import ScreeningList from './components/screening-list';
import useAppBarTitle from 'hooks/use-app-bar-title';

const pageTitle = 'Screenings';

const Screenings: React.FC = () => {
    useAppBarTitle(pageTitle);
    const { match } = useRouter();

    return (
        <LayoutDashboard>
            <Switch>
                <Route exact path={match.path}>
                    <ScreeningList />
                </Route>
            </Switch>
        </LayoutDashboard>
    );
};

export default Screenings;
